<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-26 09:58:36
 * @FilePath: 
 * @Description: 注册微会员验证手机号
-->
<template>
  <div class="full_page register_page">
    <div class="store_logo_con">
      <img :src="logoImgUrl" alt="" />
    </div>
    <div class="register_form_con" v-if="mRegisterMemberByMiniApp === false">
      <van-form @submit="onSubmit">
        <van-field v-model="formData.MobilePhone" type="tel" name="MobilePhone" maxlength="11" label="手机号"
          placeholder="请输入手机号" :error="false" :rules="[{ required: true, message: '请输入手机号' }]">
          <template #button>
            <g-send-code :disabled.sync="codeDiabled" :phone="formData.MobilePhone" :click="handleGetCode"
              color="var(--tc)" ref="sendRef"></g-send-code>
            <!-- <van-button size="small" type="primary" @click="handleGetCode">获取验证码</van-button> -->
          </template>
        </van-field>
        <van-field v-model="formData.SmsCode" type="number" maxlength="6" name="SmsCode" label="验证码"
          placeholder="请输入验证码" :error="false" :rules="[{ required: true, message: '请输入验证码' }]" />
        <div style="margin: 16px">
          <van-button block color="var(--tc)" native-type="submit" :loading="isSubmiting"
            loading-text="提交中...">提交</van-button>
        </div>
      </van-form>
    </div>

    <div class="register_form_con" v-else>
      <van-form>
        <div class="register_btn_wrap">
          <wx-open-launch-weapp
            v-if="canLaunchMiniApp"
            id="launch-btn"
            class="miniapp-launch-btn"
            :appid="appid"
            :username="username"
            :path="path"
            @launch="handleLaunchMiniApp"
            @error="handleLaunchMiniAppError"
          >
            <script type="text/wxtag-template">
              <style>
                .miniapp-launch-btn-inner {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 100%;
                  height: 44px;
                  line-height: 44px;
                  border-radius: 4px;
                  background: #323233;
                  color: #fff;
                  opacity:1;
                  font-size: 16px;
                  font-weight: 500;
                  box-sizing: border-box;
                }
              </style>
              <div class="miniapp-launch-btn-inner">注册</div>
            </script>
          </wx-open-launch-weapp>
          <van-button
            v-else
            block
            color="#323233"
            native-type="button"
            @click="handleLaunchMiniAppUnavailable"
          >注册</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import { validMiniMember } from "@/api/member";
import { handleLocalStorage } from "@/utils";
import wx from "weixin-js-sdk";
import wxConfig from "@/utils/wxConfig";
export default {
  name: "ValidMember",
  props: {},
  data() {
    return {
      mRegisterMemberByMiniApp: true, // 是否跳转到小程序注册
      logoImgUrl: "",
      codeDiabled: false,
      formData: {
        MobilePhone: "",
        SmsCode: "",
      },
      isSubmiting: false,
      returnurl: '',
      canLaunchMiniApp: false,
      appid:'wxe45a135e6aef89b0',
      username:'gh_34ea4ccb9564',
      H5OpenId:'',
      path:'pages/initOpenidPage/initOpenidPage.html'
    };
  },
  components: {},
  onload(option) {
  },

  watch: {
    "formData.MobilePhone"(val) {
      if (val.length === 11) {
        this.codeDiabled = false;
      } else {
        this.codeDiabled = true;
      }
    },
  },
  created() {
   
  },
  mounted() {
    const vpnInfo = this.$store.state.vpnInfo;
    console.log("vpnInfo==== "+JSON.stringify(vpnInfo))
    console.log(this.$store);
    const imgArr = vpnInfo.Claims;
    if (imgArr instanceof Array && imgArr.length > 0) {
      const imgItem = imgArr.find((subItem) => subItem.TypeId === 2);
      if (imgItem) {
        this.logoImgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
      }
    }
    this.mRegisterMemberByMiniApp = vpnInfo.RegisterMemberByMiniApp||false 
    let tempReturnurl = handleLocalStorage.get('returnurl')
    this.H5OpenId = localStorage.getItem("openId")
    console.log("tempReturnurl ==== "+tempReturnurl);
    if (tempReturnurl && tempReturnurl != undefined && (tempReturnurl + '').length > 10) {
      this.returnurl = tempReturnurl.replace('/MinMember/ValidMember?returnurl=', '')
      this.returnurl = decodeURIComponent(this.returnurl)
      const hashIndex = this.returnurl.indexOf('#')
      const result = this.returnurl.substring(hashIndex + 1)
      this.returnurl = result
      this.path = this.path + "?returnurl=" +this.returnurl+"&H5OpenId="+this.H5OpenId
      this.path =  encodeURIComponent(this.path)
      console.log("this.path ===" +this.path);
    }
     // 跳转小程序模式下，先初始化微信开放标签能力。
    if (this.mRegisterMemberByMiniApp === true) {
        this.initWechatSDK();
    }
  },
  methods: {
    initWechatSDK() {
      this.canLaunchMiniApp = false;
      wxConfig.getWxParameter(this);
      wx.ready(() => {
        this.canLaunchMiniApp = true;
        console.log('微信 JSSDK 初始化成功');
      });
      wx.error((err) => {
        this.canLaunchMiniApp = false;
        console.log('微信 JSSDK 初始化失败:', err);
      });
    },
    handleLaunchMiniApp() {
      console.log('跳转小程序成功');
    },
    handleLaunchMiniAppError(e) {
      const errMsg = e && e.detail && e.detail.errMsg ? e.detail.errMsg : '打开小程序失败，请稍后重试';
      this.$toast(errMsg);
    },
    handleLaunchMiniAppUnavailable() {
      this.$toast('请在微信内打开页面后再注册');
    },

    handleGetCode() {
      $http(
        "wechath5/zh-cn/v1/member/sendsmscode?phone=" +
        this.formData.MobilePhone
      ).then((res) => {
        this.$toast("发送验证码成功");
        this.$refs.sendRef.activeCode();
      });
    },
    onSubmit(values) {

      console.log("submit", values);
      this.isSubmiting = true;
      validMiniMember(values)
        .then((res) => {
          this.isSubmiting = false;
          this.$router.push({
            name: "RegisteredMember",
            query: { phone: this.formData.MobilePhone, returnurl: this.returnurl },
          });
        })
        .catch(() => {
          this.isSubmiting = false;
        });
    }, 
  },
};
</script>
<style scoped lang="scss">
.register_page {
  background: linear-gradient(180deg, #f4f3f0 0%, #fff 100%);
  padding-top: 1px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .store_logo_con {
    margin: 290px 135px 0;

    img {
      width: 100%;
    }
  }

  .register_form_con {
    padding: 0 30px 300px;
  }
}

.register_btn_wrap {
  position: relative;
  margin: 16px;
}

.miniapp-launch-btn {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 44px;
}
</style>
